import { Collapse, Divider, InputNumber } from 'antd';
import styled from 'styled-components';

export const StyledInput = styled(InputNumber)`
  width: 70px;
  margin-right: 8px;
`;

export const StyledUnit = styled.div`
  padding-top: 5px;
`;

export const StyledConfigLabel = styled.div`
  color: #777;
  padding: 0 0 5px;
  font-weight: 500;
  font-size: 14;
  display: flex;
`;

export const StyledNestedConfigLabel = styled(StyledConfigLabel)`
  padding-left: 16px;
`;

export const StyledInputWrapper = styled.div`
  padding: 0 0 8px;
  font-weight: 500;
  font-size: 14;
  display: flex;
`;

export const StyledBetaMetric = styled.sup`
  color: #999;
  font-size: 10px;
  margin-left: 4px;
`;

export const StyledCollapse = styled(Collapse)`
  margin: 10px 0 30px;

  .ant-collapse-extra {
    .ant-space-item {
      .ant-form-item {
        margin-bottom: 0;
      }
    }
  }

  .ant-collapse-item .ant-collapse-header {
    padding: 10px 15px 6px;
  }

  .ant-collapse-header-text {
    color: black;
    flex: auto !important;

    .ant-col {
      padding: 0 !important;
    }
  }
`;

export const SubscriptionCategoryName = styled.div`
  font-size: 16px;
  font-weight: 500;
  padding: 0 0 0 20px;
`;

export const ImpactedFieldsWrapper = styled.div`
  margin-top: 12px;
`;

export const StyledDivider = styled(Divider)`
  margin: 10px 0;
  display: flex;
  align-items: center;

  .highlighted-text {
    height: unset !important;
  }
`;

export const StyledTitle = styled.span`
  flex: 1;
  display: inline-flex;
  align-items: center;
`;

// Groups the KPI dropdown together with its Beta KPI-based metrics in one bordered
// box, since the selected KPI is what those metrics are evaluated against.
export const StyledKpiMetricsBox = styled.div`
  margin: 10px 0 30px;
  padding: 16px 20px;
  border: 1px solid #e8e8e8;
  border-radius: 8px;
  background: #fafafa;
`;

export const StyledKpiMetricsTitle = styled.div`
  font-size: 16px;
  font-weight: 500;
  color: black;
  margin-bottom: 0;
  display: flex;
  align-items: center;
`;
